import {
  ColumnFilterHeader,
  matchAmountFilter,
} from '../../../components/admin/ColumnFilterHeader';
import { formatCurrency } from '../receptionistData';
import {
  PAYMENT_METHOD_OPTIONS,
  splitAmountForMethod,
} from '../../../utils/splitPaymentUtils';

export function saleMethodFilterDefaults() {
  return Object.fromEntries(
    PAYMENT_METHOD_OPTIONS.map(({ key }) => [`method_${key}`, '']),
  );
}

export function matchSaleMethodFilters(row, filters) {
  return PAYMENT_METHOD_OPTIONS.every(({ key }) => {
    const raw = filters[`method_${key}`];
    if (raw == null || raw === '' || raw === 'all') return true;
    const amt = splitAmountForMethod(row, key);
    return matchAmountFilter(amt, raw, formatCurrency);
  });
}

export function SaleMethodColumnHeaders({
  sales: _sales,
  filters,
  openFilterKey,
  toggleFilter,
  updateFilter,
}) {
  return PAYMENT_METHOD_OPTIONS.map(({ key, label }) => (
    <ColumnFilterHeader
      key={key}
      label={label}
      filterKey={`method_${key}`}
      openKey={openFilterKey}
      onToggle={toggleFilter}
      filters={filters}
      onFilterChange={updateFilter}
      placeholder={`Search ${label}...`}
    />
  ));
}

export function SaleMethodCells({ row }) {
  return PAYMENT_METHOD_OPTIONS.map(({ key }) => {
    const amt = splitAmountForMethod(row, key);
    return (
      <td key={key} className={amt > 0 ? 'finance-amount-positive' : ''}>
        {amt > 0 ? formatCurrency(amt) : '—'}
      </td>
    );
  });
}

export const SALE_METHOD_COLUMN_COUNT = PAYMENT_METHOD_OPTIONS.length;
